import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Row, Col } from 'react-bootstrap';
import { clientService } from '../../services/api';
import { toast } from 'react-toastify';

interface ClientFormProps {
  show: boolean;
  onHide: () => void;
  onSuccess: () => void;
  client?: any; // 👈 pour édition
}

const initialState = {
  name: '',
  ice: '',
  if_number: '',
  rc: '',
  address: '',
  email: '',
  phone: '',
  fax: '',
};

const ClientForm: React.FC<ClientFormProps> = ({
  show,
  onHide,
  onSuccess,
  client,
}) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(initialState);

  // ✅ Remplir formulaire en mode édition
  useEffect(() => {
    if (client) {
      setFormData({
        name: client.name || '',
        ice: client.ice || '',
        if_number: client.if_number || '',
        rc: client.rc || '',
        address: client.address || '',
        email: client.email || '',
        phone: client.phone || '',
        fax: client.fax || '',
      });
    } else {
      setFormData(initialState);
    }
  }, [client, show]);

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleClose = () => {
    onHide();
    setFormData(initialState);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (client) {
        // ✅ UPDATE
        await clientService.update(client.id, formData);
        toast.success('Client modifié avec succès');
      } else {
        // ✅ CREATE
        await clientService.create(formData);
        toast.success('Client créé avec succès');
      }

      onSuccess();
      handleClose();
    } catch (error) {
      console.error(error);
      toast.error("Erreur lors de l'enregistrement");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {client ? 'Modifier client' : 'Nouveau client'}
        </Modal.Title>
      </Modal.Header>

      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Nom *</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Téléphone</Form.Label>
                <Form.Control
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Fax</Form.Label>
                <Form.Control
                  type="text"
                  name="fax"
                  value={formData.fax}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>ICE</Form.Label>
                <Form.Control
                  type="text"
                  name="ice"
                  value={formData.ice}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>IF</Form.Label>
                <Form.Control
                  type="text"
                  name="if_number"
                  value={formData.if_number}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>RC</Form.Label>
                <Form.Control
                  type="text"
                  name="rc"
                  value={formData.rc}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3">
            <Form.Label>Adresse</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="address"
              value={formData.address}
              onChange={handleInputChange}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Annuler
          </Button>

          <Button type="submit" variant="primary" disabled={loading}>
            {loading
              ? client
                ? 'Modification...'
                : 'Création...'
              : client
              ? 'Modifier'
              : 'Créer le client'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ClientForm;